const initials = "dashboardData/";

export const UPDATE_DASHBOARD_DATA_REDUCER = `${initials}UPDATE_DASHBOARD_DATA_REDUCER`;